import { getView, requireAuth } from '@/lib/utils';
import { AssetsPage } from '@/data/appInformationItems';

export default {
  path: '/locations',
  component: getView('pages/PageMaps'),
  name: 'locations',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Maps',
    roles: ['operator'],
    information: AssetsPage,
    showBottomMenu: true,
  },
};
